<template>
  <div v-if="showModal">
    <AddExercise @close="showModal = false" @save="saveExercise"></AddExercise>
  </div>
  <ExerciseList v-if="!loading" :exerciseList="userExercises"></ExerciseList>
  <div class="footer">
    <button type="button" class="btn btn-primary" @click="this.addExercise()">Add Exercise</button>
  </div>
</template>

<script>
import ExerciseList from "@/components/ExerciseList";
import {dbConnection} from "@/firestore/firestore";
import { provideToast, useToast } from "vue-toastification/";
import AddExercise from "@/components/AddExercise";

export default {
  name: 'ExerciseView',
  components: {
    ExerciseList,
    AddExercise,
  },
  setup() {
    provideToast({ maxToasts: 5 });
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      loading:true,
      userExercises: [],
      dbConnection,
      uid: null,
      workout: null,
      workoutToEdit: null,
      showAddEditWorkoutModal: false,
      documents: [],
      showModal: false,

    }
  },
  mounted() {
    this.uid = localStorage.uid;
    this.dbConnection.getExerciseList(this.uid).then(exerciseList => {
      this.userExercises = exerciseList
      this.loading = false
    })
  },
  methods: {
    addExercise() {
      this.showModal = true
    },
    saveExercise(exercise) {
      this.showModal = false;
      exercise.owner = this.uid;
      exercise.added = Date.now();
      this.dbConnection.saveExercise(exercise).then(() => {
        this.dbConnection.getExerciseList(this.uid).then(exerciseList => {
          this.userExercises = exerciseList
          this.loading = false
        });
        this.toast.success('Exercise saved');
      })
    }
  }
}
</script>